module.exports = __webpack_public_path__ + "img/user-roles.61119a4f.svg";